/** Shared hook: the full IANA time-zone list, fetched from the backend
 * (Django `zoneinfo.available_timezones()`) so the pickers only ever offer
 * zones the backend accepts. Long-cached — the list is effectively static. */
import { useQuery } from "@tanstack/react-query";

import { ApiPaths, api } from "@/lib/api";

export function useTimezones() {
  return useQuery({
    queryKey: ["timezones"],
    queryFn: async () =>
      (await api.get<{ timezones: string[] }>(ApiPaths.timezones)).data.timezones,
    staleTime: 24 * 60 * 60 * 1000, // a day — the tz db rarely changes
    gcTime: 24 * 60 * 60 * 1000,
  });
}
